
import axios from 'axios';
import { getCookie } from './cookiejs'
import Vue from 'vue'
import router from '../router'

/*import { Message } from 'element-ui';*/

/*
axios.defaults.timeout = 5000;
axios.defaults.baseURL ='';
*/
// axios.defaults.headers.post['Content-Type'] = 'application/json'; // 改变 post 请求的内容类型 !!! 慎用，影响全局，请单独使用

//http request 拦截器 通过这个，我们就可以把Cookie传到后台
axios.interceptors.request.use(
  config => {
    //在发送请求之前做某事
    const token = getCookie('JWT-TOKEN');//获取Cookie 'JWT-TOKEN'cookie的名称
    //config.data = JSON.stringify(config.data);

    //console.log('sdsd ' +  window.location.pathname);

    config.headers['X-JWT-TOKEN'] = token;
    //if(token){
    //config.params = {}//后台接收的参数，
    //}
    // alert('token  :  ' + token)
    //console.log('token  :  ' + token)
    return config;
  },
  err => {
    //console.log("===拦截==err",err);
    return Promise.reject(err);
  }
);


//http response 拦截器

axios.interceptors.response.use(
  response => {
    //console.log("===拦截==",response);
    if (response.data.ErrorCode == '401' || response.data.ErrorCode == 'AuthenticationFailed') {
      if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
        sessionStorage.removeItem("SalesInfos");
      }
      if (sessionStorage.getItem('SalesInfos') && ![null, 'null', undefined, 'undefined'].includes(sessionStorage.getItem('SalesInfos'))) {
        sessionStorage.removeItem("loginMessage");
      }
      window.location.href = Vue.prototype.$nuxtPage + 'login/CSTCenter?ReturnUrl=' + escape(window.location.href);
      // //判断当前的路由是否是目标路由
      // if(router.currentRoute.name == "target"){
      //   //跳转回login路由，并把目标路由的url路径保存在login的query中
      //
      //   router.replace({
      //    // name:"login",
      //     query: {redirect: router.currentRoute.fullPath}
      //   })
      // }else{
      //   /* 普通401拦截直接返回到登录页面 */
      //   //router.push('/login');
      //   window.location.href =Vue.prototype.$apiAll+'CSTCenter/Login.htm';
      // }

      // window.location.href =Vue.prototype.$apiAll+'CSTCenter/Login.htm?ResultUrl='+'';
      //
      // console.log('nihap22222:'+JSON.stringify(response.data.ErrorCode));
      // router.push({
      //   //path:this.$apiAll+"CSTCenter/Login.htm",
      //   querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
      //
      //
      // })
    }

    else if (response.data.ErrorCode == '6101' || response.data.ErrorCode == '6103') {
      window.location.href = Vue.prototype.$apiAir + 'notCertified?form=order';
      //直接不返回结果了


    } else if (response.data.ErrorCode == '6102') {
      // router.push('/notCertified?form=order')
      window.location.href = Vue.prototype.$apiAir + 'notCertified?form=order';
    }
    return response;
  },
  error => {
    const { status } = error.response
      if (status === 401 || error.response.data.ErrorCode == 'AuthenticationFailed') {
      // todo: 重定向到登录页
      window.location.href = Vue.prototype.$nuxtPage + 'login/CSTCenter?ReturnUrl=' + escape(window.location.href);
      //router.replace('/login')
      }
    return Promise.reject(error)
  }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.get(url, { params: params, })
      .then(response => {
        resolve(response.data);

      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response.data);

      }, err => {
        reject(err)

      })
  })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data)
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function Del(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, { data: params })
      .then(response => {
        resolve(response.data);
      }, err => {
        reject(err)
      })
  })
}

/**
 * 文件流下载
 * @param method
 * @param url
 * @param data
 * @returns {Promise}
*/
export function fileDownload(method, url, params = {}) {
  return new Promise((resolve, reject) => {
    let axiosRequestParams = {
      method,
      url,
      responseType: 'arraybuffer', // 告诉axios请求的是二进制数据流
      data: params, // post
      params: params // get
    }
    let value = method.toLowerCase() == 'post' ? 'params' : 'data';
    delete axiosRequestParams[value];
    axios(axiosRequestParams).then(response => {
      resolve(response);
    }, err => {
      reject(err);
    });
  });
}









// WEBPACK FOOTER //
// ./src/ask/axios.js